import classNames from "classnames";
import React from "react";

import { useBreakpoint } from "@utils/breakpoints/breakpoints.provider";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { SearchItem } from "@components/Store/StoreSearchInput/storeSearchInput.types";

import { StoreSearchFilters } from "../filters/storeSearchFilters.container";
import { StoreSearchInput } from "../input/input.container";
import "./storeSearchControls.scss";
import { SwitchTab } from "./switchTab/switchTab.container";

type StoreSearchControlsComponentProps = {
    selectedSearchItem?: SearchItem;
    filtersOpen: boolean;
    toggleFilters: () => void;
};

export const StoreSearchControlsComponent = ({
    selectedSearchItem,
    filtersOpen,
    toggleFilters,
}: StoreSearchControlsComponentProps) => {
    const { t } = useGranite();

    const { breakpoints } = useBreakpoint();

    return (
        <div
            className={classNames(
                "store-search-controls",
                filtersOpen && "store-search-controls--filters-open",
            )}
        >
            <section>
                <StoreSearchInput />
            </section>
            <section className={"store-search-controls__actions"}>
                <Button
                    className={
                        "store-search-controls__actions__open-filters-button"
                    }
                    type={"button"}
                    color={"gray"}
                    onClick={toggleFilters}
                >
                    <span>
                        <i className={"las la-filter la-lg pr-2"}></i>
                        {t("form.searchstore.filteron")}
                    </span>
                    <i
                        className={
                            "las la-angle-down la-lg store-search-controls__actions__open-filters-button__arrow"
                        }
                    ></i>
                </Button>
                {!breakpoints.md && <SwitchTab />}
            </section>
            {filtersOpen && (
                <>
                    <section className={"store-search-controls__filters"}>
                        <StoreSearchFilters />
                    </section>
                    <section>
                        <Button
                            type={"button"}
                            onClick={toggleFilters}
                            color={"gray"}
                            fullWidth={true}
                        >
                            {t("form.searchstore.applyFilters")}
                        </Button>
                    </section>
                </>
            )}
        </div>
    );
};
